export enum PhotoRequirement {
    None = 0,
    Required = 1,
    Prohibited = 2
}
